// extracted by mini-css-extract-plugin
module.exports = {"theme":"#00a0ac"};